import(/* webpackMode: "eager" */ "/vercel/path0/components/service/ReviewForm.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/service/ReviewList.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")